import React from 'react';

/**
 * Returns the most recent non-null/undefined value it has been handed.
 *
 * Useful for keeping the last "good" value rendered while a fresh one is being
 * recomputed or refetched (e.g. a chart config that briefly goes `null` during
 * a data refetch) — without the infinite-loop hazard of the render-phase
 * "store previous value" setState pattern. The value is cached in a ref, so the
 * result is referentially stable across renders regardless of whether the
 * upstream inputs are stable, and no state update is scheduled during render.
 */
const useLastDefined = <T>(value: T | null | undefined): T | null => {
  const ref = React.useRef<T | null>(value ?? null);
  if (value != null) {
    ref.current = value;
  }
  return ref.current;
};

export default useLastDefined;
